module.exports = __webpack_public_path__ + "img/keycap-digit-one.68556462.png";